var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.63965 8.67485H9.69965V7.34485H3.63965V8.67485Z",
    fill: "#FF3300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79004 11.565L10.8 8.55501C11.1 8.255 11.1 7.76501 10.8 7.465L7.80004 4.455L7.92004 4.305C8.12004 4.045 8.34004 3.825 8.59004 3.625L8.74004 3.505L11.75 6.515C12.12 6.885 12.32 7.36501 12.36 7.84501C12.36 7.89501 12.36 7.945 12.36 7.995C12.36 8.045 12.36 8.095 12.36 8.145C12.32 8.635 12.12 9.105 11.75 9.485L8.74004 12.495L8.59004 12.375C8.35004 12.175 8.12004 11.955 7.92004 11.705L7.80004 11.555L7.79004 11.565Z",
    fill: "#FF3300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.6d64862615d06a5eaede3b5e38b795e8.svg";
export { ForwardRef as ReactComponent };